import { create } from "zustand";

import {
  CompanyPaymentPeriod,
  type CompanyPaymentPeriodType,
  SIGNUP_ALLOWED_PLANS,
  type SignupAllowedPlan,
} from "~/common/api/validation/auth-schemas";

export const isSignupAllowedPlan = (
  plan: string,
): plan is SignupAllowedPlan => {
  return SIGNUP_ALLOWED_PLANS.includes(plan as SignupAllowedPlan);
};

export const isValidPaymentPeriod = (
  period: string,
): period is CompanyPaymentPeriodType => {
  return Object.values(CompanyPaymentPeriod).includes(
    period as CompanyPaymentPeriodType,
  );
};

interface SignupPlanState {
  plan: SignupAllowedPlan | null;
  period: CompanyPaymentPeriodType | null;
  setPlanAndPeriod: (
    plan: SignupAllowedPlan,
    period: CompanyPaymentPeriodType,
  ) => void;
  clearPlanAndPeriod: () => void;
}

export const useSignupPlanStore = create<SignupPlanState>((set) => ({
  plan: null,
  period: null,
  setPlanAndPeriod: (plan, period) => set({ plan, period }),
  clearPlanAndPeriod: () => set({ plan: null, period: null }),
}));
